import { useContext } from 'react';
import classNames from 'clsx';
import css from '../../payment/payment.module.scss';
import {
  SUBSCRIPTION_UNAVAILABLE_TITLE,
  SUBSCRIPTION_UNAVAILABLE_DESCRIPTION,
} from '../../../constants/localizations/subscription';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';

export default function SubscriptionServiceUnavailable() {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  return (
    <div className={css.containerRestrictions}>
      <div className="row">
        <div className="col-xs-12">
          <h1 className={css.subscriptionUnavailableTitle}>
            {getLocalizedText(SUBSCRIPTION_UNAVAILABLE_TITLE)}
          </h1>
        </div>
      </div>
      <div className="row">
        <div
          className={classNames(
            'col-xs-12',
            css.subscriptionUnavailableSubTitle,
          )}
        >
          {getLocalizedText(SUBSCRIPTION_UNAVAILABLE_DESCRIPTION)}
        </div>
      </div>
    </div>
  );
}
